import { currencyFormatter } from "../components/CalculatorResults";

export const getNumericValue = (amount: string) => parseInt(amount.replace(/\D/g, ""), 10);

export const getCostPerItem = (
  result: string,
  cost: number,
  isCurrency: boolean,
) => {
  const amount = Math.floor(getNumericValue(result) / cost);
  return isCurrency
    ? currencyFormatter.format(amount).replace(/\D00$/, "")
    : amount;
};
